import { render, staticRenderFns } from "./FiltroFechamentoPeriodoLetivo.vue?vue&type=template&id=0bfe1df6&"
import script from "./FiltroFechamentoPeriodoLetivo.vue?vue&type=script&lang=js&"
export * from "./FiltroFechamentoPeriodoLetivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports